<template>
  <div
    :class="{ 'editable-hover': hover && editable }"
    @mouseover="hover = true"
    @mouseout="hover = false"
  >
    <div class="row" @click="handleClick">
      <div class="col-sm-6">
        <div v-for="({ name, isOnsite, isRemote }, key) in selectedMarkets" :key="key">
          {{ $t(name) }}
          <small v-if="!(isOnsite && isRemote)">
            ({{ isOnsite ? $t('On site') : $t('Remote') + ' ' + $t('only') }})
          </small>
        </div>
      </div>
      <div class="col-sm-6">
        <i v-show="hover && editable" class="zmdi zmdi-edit c-gray" />
      </div>
    </div>

    <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
    <BaseModal
      v-if="isMe"
      :header-text="$t('Edit your market availability')"
      :modal-id="'markets-modal'"
      :is-open="showModal"
      :save-state="$store.state.user.saveStatus"
      data-test="markets-modal"
      @opened="handleModalOpened"
      @cancel="handleModalCancel"
      @save="handleModalSave"
    >
      <div class="p-t-15 p-b-15">
        <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
        <market-selection
          use-vuex-store
          show-availability
          :show-primary-market-selection="false"
          :show-headers="false"
        />
      </div>
    </BaseModal>
  </div>
</template>

<script>
import { SET_EDIT_UNSAVED, UPDATE_USER_STATE } from '@/state/mutation-types'
import { UPDATE_USER_MARKETS } from '@/state/action-types'
import { filterObject } from '@/utils/tools'

export default {
  props: {
    initialMarketsState: { type: Object, required: true },
    isMe: { type: Boolean, required: true },
  },
  data() {
    return {
      marketSelectionWhenOpeningModal: {},
      hover: false,
      showModal: false,
    }
  },
  computed: {
    editable() {
      return this.isMe && this.$store.state.edit.on
    },
    selectedMarkets() {
      return filterObject(this.$store.state.user.markets, (_, { isSelected }) => isSelected)
    },
  },
  created() {
    this.$store.commit(UPDATE_USER_STATE, {
      fieldName: 'markets',
      fieldValue: this.initialMarketsState,
    })
  },
  methods: {
    handleClick() {
      if (this.editable) {
        this.showModal = !this.showModal
      }
    },
    handleModalOpened() {
      // keep a copy of the markets state when initially
      // opening modal in case we need to revert it
      this.marketSelectionWhenOpeningModal = JSON.parse(
        JSON.stringify(this.$store.state.user.markets),
      )

      // We lock the ability to navigate so that we don't have them accidentally navigate and lose any progress
      this.$store.commit(SET_EDIT_UNSAVED, true)
    },
    handleModalCancel() {
      // Restore the initial state when modal cancelled without save
      this.$store.commit(UPDATE_USER_STATE, {
        fieldName: 'markets',
        fieldValue: this.marketSelectionWhenOpeningModal,
      })
      this.showModal = false
      // We unlock our lock
      this.$store.commit(SET_EDIT_UNSAVED, false)
    },
    async handleModalSave() {
      this.$store.commit(SET_EDIT_UNSAVED, true)
      await this.$store.dispatch(UPDATE_USER_MARKETS, this.account.globalId)
      this.$store.commit(SET_EDIT_UNSAVED, false)
      this.showModal = false
    },
  },
}
</script>

<style scoped lang="scss">
.editable-hover {
  cursor: pointer;
}
</style>
